import React from 'react';
import { Field, FieldArray, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { MachineFormValidator } from './MachineFormValidator';
import Card from '../../../shared/components/Card';
import CardHeader from '../../../shared/components/card-header/CardHeader';
import CardBody from '../../../shared/components/CardBody';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { FormText } from '../../../shared/components/FormText';
import Row from '../../../shared/components/Row';
import { FormSwitch } from '../../../shared/components/FormSwitch';
import { FormSubmit } from '../../../shared/components/FormSubmit';
import DocumentSchemaType from '../../../shared/model/DocumentSchemaType';
import { ResourceContractorSchemas } from '../../../shared/components/predefined-fields/resource-contractor-schema/ResourceContractorSchemas';

const FORM = {
    NAME: 'ContractorMachineForm',
    FIELDS: {
        LICENSE_PLATE: 'licensePlate',
        STATE: 'state',
        BRAND: 'brand',
        MODEL: 'model',
        DESCRIPTION: 'description',
        CONTRACTOR_SCHEMAS: 'contractorSchemas',
    },
};

class ContractorMachineForm extends React.Component {

    render() {
        const {
            title,
            onSubmit,
            handleSubmit,
            initialValues,
            machineId,
            handleSetRefreshQrToken,
            refreshQrToken,
            handleTokenLoading,
            loading,
        } = this.props;

        if ( initialValues.contractorId === -1 ) return null;

        return (
            <Card loading={loading}>
                <CardHeader title={title.toUpperCase()}/>
                <CardBody>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Field
                                col="col-md-6"
                                name={FORM.FIELDS.LICENSE_PLATE}
                                label={I18nUtils.tr('TR_MATRICULA_CODIGO_O_NUMERO_DE_SERIE')}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_LA_IDENTIFICACION_DE_LA_MAQUINARIA')}
                                component={FormText}
                            />
                            <Field
                                col="col-md-6"
                                name={FORM.FIELDS.STATE}
                                label={I18nUtils.tr('TR_ESTADO')}
                                labelDisabled={I18nUtils.tr('TR_INACTIVO')}
                                labelEnabled={I18nUtils.tr('TR_ACTIVO')}
                                component={FormSwitch}
                            />
                        </Row>
                        <Row>
                            <Field
                                col="col-md-6"
                                name={FORM.FIELDS.BRAND}
                                label={I18nUtils.tr('TR_MARCA')}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_LA_MARCA_DE_LA_MAQUINARIA')}
                                component={FormText}
                            />
                            <Field
                                col="col-md-6"
                                name={FORM.FIELDS.MODEL}
                                label={I18nUtils.tr('TR_MODELO')}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_EL_MODELO_DE_LA_MAQUINARIA')}
                                component={FormText}
                            />
                        </Row>
                        <Row>
                            <Field
                                col="col-md-12"
                                name={FORM.FIELDS.DESCRIPTION}
                                label={I18nUtils.tr('TR_DESCRIPCION')}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_UNA_DESCRIPCION_DE_LA_MAQUINARIA')}
                                component={FormText}
                            />
                        </Row>
                        <Row>
                            <div className="col-sm-12 form-field-list">
                                <label>{I18nUtils.tr('TR_CONTRATISTA_ESQUEMA_DOCUMENTACION')}</label>
                                <FieldArray
                                    name={FORM.FIELDS.CONTRACTOR_SCHEMAS}
                                    component={ResourceContractorSchemas}
                                    initialValues={initialValues}
                                    documentSchemaType={DocumentSchemaType.MACHINE}
                                    machineId={machineId}
                                    handleSetRefreshQrToken={handleSetRefreshQrToken}
                                    refreshQrToken={refreshQrToken}
                                    handleTokenLoading={handleTokenLoading}
                                />
                            </div>
                        </Row>
                        <Row>
                            <Field
                                label={I18nUtils.tr('TR_GUARDAR')}
                                name="submit"
                                col="col-md-6 col-md-offset-6"
                                component={FormSubmit}
                            />
                        </Row>
                    </form>
                </CardBody>
            </Card>
        );
    }
}

export const MachineForm = reduxForm({
    form: FORM.NAME,
    validate: MachineFormValidator.validate,
})(ContractorMachineForm);

MachineForm.propTypes = {
    title: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    initialValues: PropTypes.object.isRequired,
    machineId: PropTypes.number,
    handleSetRefreshQrToken: PropTypes.func,
    refreshQrToken: PropTypes.bool,
    handleTokenLoading: PropTypes.func,
    loading: PropTypes.bool,
};

MachineForm.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-contractors/machine/form/MachineForm.jsx